import useSwipe from "./useSwipe";

export default useSwipe;
